import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {
  Briefcase,
  Calendar,
  Check,
  ChevronRight,
  FileBarChart,
  Filter,
  LayoutDashboard,
  LogOut,
  LucideAngularModule,
  Settings,
  Sparkles,
  User,
  UserCog,
  Users,
} from 'lucide-angular';
import { CurrentUser, SidebarView, UserRole } from '../../models/layout.models';

@Component({
  selector: 'app-sidebar',
  imports: [LucideAngularModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Sidebar {
  readonly activeView = input.required<SidebarView>();
  readonly role = input.required<UserRole>();
  readonly currentUser = input.required<CurrentUser>();
  // readonly waitlistStatus = input<'idle' | 'success'>('idle'); // TODO: Lista de espera será desenvolvido em outro momento

  readonly changeView = output<SidebarView>();
  readonly toggleRole = output<UserRole>();
  readonly logout = output<void>();
  readonly requestWaitlist = output<void>();

  readonly icons = {
    briefcase: Briefcase,
    calendar: Calendar,
    check: Check,
    chevronRight: ChevronRight,
    fileBarChart: FileBarChart,
    filter: Filter,
    layoutDashboard: LayoutDashboard,
    logOut: LogOut,
    settings: Settings,
    sparkles: Sparkles,
    user: User,
    userCog: UserCog,
    users: Users,
  };

  navigate(view: SidebarView): void {
    this.changeView.emit(view);
  }

  setRole(role: UserRole): void {
    this.toggleRole.emit(role);
  }

  handleLogout(): void {
    this.logout.emit();
  }

  // TODO: Lista de espera será desenvolvido em outro momento
  // handleWaitlistRequest(): void {
  //   this.requestWaitlist.emit();
  // }
}
